(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polkapop-collection-page"] && !Shopify.designMode) return;
  try {
    
/* Product card interactions */
const cards = document.querySelectorAll('.ppcv2-product-card');
cards.forEach(card => {
  card.addEventListener('click', () => {
    const wasActive = card.classList.contains('is-active');
    cards.forEach(c => c.classList.remove('is-active'));
    if (!wasActive) card.classList.add('is-active');
  });
  card.addEventListener('keydown', event => {
    if (event.key === 'Escape') card.classList.remove('is-active');
  });
});

document.addEventListener('click', event => {
  if (!event.target.closest('.ppcv2-product-card')) {
    cards.forEach(c => c.classList.remove('is-active'));
  }
});

/* FAQ accordion */
document.querySelectorAll('.ppcv2-faq-question').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.closest('.ppcv2-faq-item');
    const open = item.classList.toggle('open');
    button.setAttribute('aria-expanded', String(open));
  });
});

/* Hero slider */
document.querySelectorAll('.ppcv2-slider').forEach(slider => {
  const track = slider.querySelector('.ppcv2-slider-track');
  const slides = slider.querySelectorAll('.ppcv2-slide');
  const dots = slider.querySelectorAll('.ppcv2-slider-dot');
  const prevBtn = slider.querySelector('.ppcv2-slider-prev');
  const nextBtn = slider.querySelector('.ppcv2-slider-next');
  const total = slides.length;
  if (total < 2) return;

  let current = 0;
  let autoplayTimer = null;
  let paused = false;
  const autoplay = slider.dataset.autoplay === 'true';
  const interval = parseInt(slider.dataset.interval, 10) || 5000;

  function goTo(index, announce) {
    current = ((index % total) + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    slides.forEach((s, i) => {
      s.classList.toggle('is-active', i === current);
      const link = s.querySelector('.ppcv2-slide-link');
      if (link) link.tabIndex = i === current ? 0 : -1;
    });
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === current);
      d.setAttribute('aria-selected', String(i === current));
    });
    if (announce !== false) {
      slider.setAttribute('aria-live', paused ? 'polite' : 'off');
    }
  }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    autoplayTimer = setInterval(() => goTo(current + 1), interval);
    slider.setAttribute('aria-live', 'off');
  }

  function stopAutoplay() {
    if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    slider.setAttribute('aria-live', 'polite');
  }

  if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); resetAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); resetAutoplay(); });

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      goTo(parseInt(dot.dataset.index, 10));
      resetAutoplay();
    });
  });

  function resetAutoplay() {
    if (autoplay && !paused) startAutoplay();
  }

  /* Pause on hover / focus */
  slider.addEventListener('mouseenter', () => { paused = true; stopAutoplay(); });
  slider.addEventListener('mouseleave', () => { paused = false; if (autoplay) startAutoplay(); });
  slider.addEventListener('focusin', () => { paused = true; stopAutoplay(); });
  slider.addEventListener('focusout', (e) => {
    if (!slider.contains(e.relatedTarget)) { paused = false; if (autoplay) startAutoplay(); }
  });

  /* Keyboard navigation */
  slider.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { goTo(current - 1); resetAutoplay(); e.preventDefault(); }
    else if (e.key === 'ArrowRight') { goTo(current + 1); resetAutoplay(); e.preventDefault(); }
  });

  /* Touch / swipe support */
  let touchStartX = 0;
  let touchStartY = 0;
  let touchDiffX = 0;
  let swiping = false;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    swiping = true;
  }, { passive: true });

  slider.addEventListener('touchmove', (e) => {
    if (!swiping) return;
    touchDiffX = e.touches[0].clientX - touchStartX;
    const diffY = Math.abs(e.touches[0].clientY - touchStartY);
    if (diffY > Math.abs(touchDiffX)) { swiping = false; return; }
  }, { passive: true });

  slider.addEventListener('touchend', () => {
    if (!swiping) return;
    swiping = false;
    if (Math.abs(touchDiffX) > 40) {
      goTo(current + (touchDiffX < 0 ? 1 : -1));
      resetAutoplay();
    }
    touchDiffX = 0;
  });

  /* Init */
  if (autoplay) startAutoplay();
  slider.setAttribute('aria-live', autoplay ? 'off' : 'polite');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polkapop-hero-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.pp-hero-video').forEach(video => {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.load();
    const play = () => video.play().catch(() => {});
    video.addEventListener('canplay', play, { once: true });
    play();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polkapop-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
      const heroVideo = document.querySelector('.pp-split-video-hero video');
      if (heroVideo) {
        heroVideo.muted = true;
        heroVideo.loop = true;
        heroVideo.autoplay = true;
        heroVideo.playsInline = true;
        heroVideo.play().catch(() => {});
      }

      const whyCards = Array.from(document.querySelectorAll('.why-card'));
      const whyExperience = document.querySelector('.why-experience');
      const whyTag = document.querySelector('#whyTag');
      const whyTitle = document.querySelector('#whyTitle');
      const whyText = document.querySelector('#whyText');
      const whyBottle = document.querySelector('#whyBottle');

      const setWhyCard = card => {
        whyCards.forEach(item => item.classList.remove('is-active'));
        card.classList.add('is-active');
        whyExperience?.style.setProperty('--why-soft', card.dataset.soft || '#efffd4');
        whyExperience?.style.setProperty('--why-accent', card.dataset.accent || '#7dbf1d');
        if (whyTag) whyTag.textContent = card.dataset.tag || '';
        if (whyTitle) whyTitle.textContent = card.dataset.title || '';
        if (whyText) whyText.textContent = card.dataset.text || '';
        /* keep hero image static – do not swap on hover */
      };

      whyCards.forEach(card => {
        card.addEventListener('click', () => setWhyCard(card));
        card.addEventListener('mouseenter', () => setWhyCard(card));
      });

      const momentTabs = Array.from(document.querySelectorAll('.moment-tab'));
      const momentCards = Array.from(document.querySelectorAll('.moment-card[data-moment]'));

      momentTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const filter = tab.dataset.momentFilter || 'all';
          momentTabs.forEach(item => item.classList.remove('is-active'));
          tab.classList.add('is-active');
          momentCards.forEach(card => {
            const isMatch = filter === 'all' || card.dataset.moment === filter;
            card.classList.toggle('is-featured', filter !== 'all' && isMatch);
            card.classList.toggle('is-muted', !isMatch);
          });
        });
      });

      const whySimpleText = document.querySelector('#whySimpleText');
      const whySimpleButtons = Array.from(document.querySelectorAll('.why-simple button'));
      whySimpleButtons.forEach(button => {
        button.addEventListener('click', () => {
          whySimpleButtons.forEach(item => item.classList.remove('is-active'));
          button.classList.add('is-active');
          if (whySimpleText) whySimpleText.textContent = button.dataset.whySimple || '';
        });
      });

      const recipeLab = document.querySelector('.recipe-lab');
      const recipeOptions = Array.from(document.querySelectorAll('[data-recipe-option]'));
      const recipeImage = document.querySelector('#recipeLabImage');
      const recipeTag = document.querySelector('#recipeLabTag');
      const recipeTitle = document.querySelector('#recipeLabTitle');
      const recipeDesc = document.querySelector('#recipeLabDesc');
      const recipeIngredients = document.querySelector('#recipeIngredients');
      const recipeSteps = document.querySelector('#recipeSteps');
      const recipeMore = document.querySelector('#recipeMore');
      const recipeRead = document.querySelector('[data-recipe-more]');

      const activateIngredientButtons = () => {
        Array.from(recipeIngredients?.querySelectorAll('button') || []).forEach(button => {
          button.addEventListener('click', () => {
            button.classList.toggle('is-active');
          });
        });
      };

      const renderRecipeList = (target, items, itemTag) => {
        if (!target) return;
        target.innerHTML = '';
        items.forEach(item => {
          const element = document.createElement(itemTag);
          if (itemTag === 'button') element.type = 'button';
          element.textContent = item;
          target.appendChild(element);
        });
      };

      const setRecipe = option => {
        if (!recipeLab || !option) return;
        recipeOptions.forEach(item => {
          const isActive = item === option;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
        });
        recipeLab.classList.add('is-changing');
        recipeLab.style.setProperty('--recipe-soft', option.dataset.soft || '#efffd4');
        recipeLab.style.setProperty('--recipe-accent', option.dataset.accent || '#7dbf1d');
        window.setTimeout(() => recipeLab.classList.remove('is-changing'), 220);
        if (recipeImage) {
          recipeImage.src = option.dataset.img || recipeImage.src;
          recipeImage.alt = option.dataset.alt || option.dataset.title || 'Polka Pop recipe';
        }
        if (recipeTag) recipeTag.textContent = option.dataset.tag || '';
        if (recipeTitle) recipeTitle.textContent = option.dataset.title || '';
        if (recipeDesc) recipeDesc.textContent = option.dataset.desc || '';
        renderRecipeList(recipeIngredients, (option.dataset.ingredients || '').split('|').filter(Boolean), 'button');
        recipeIngredients?.querySelector('button')?.classList.add('is-active');
        activateIngredientButtons();
        renderRecipeList(recipeSteps, (option.dataset.steps || '').split('|').filter(Boolean), 'li');
        if (recipeMore) {
          recipeMore.hidden = true;
          recipeMore.textContent = option.dataset.detail || '';
        }
        if (recipeRead) {
          recipeRead.textContent = 'Read More';
          recipeRead.setAttribute('aria-expanded', 'false');
        }
      };

      let recipeIndex = Math.max(0, recipeOptions.findIndex(option => option.classList.contains('is-active')));
      let recipeTimer = window.setInterval(() => {
        if (!recipeOptions.length) return;
        recipeIndex = (recipeIndex + 1) % recipeOptions.length;
        setRecipe(recipeOptions[recipeIndex]);
      }, 2000);

      recipeOptions.forEach((option, optionIndex) => {
        option.addEventListener('click', () => {
          recipeIndex = optionIndex;
          setRecipe(option);
          window.clearInterval(recipeTimer);
          recipeTimer = window.setInterval(() => {
            if (!recipeOptions.length) return;
            recipeIndex = (recipeIndex + 1) % recipeOptions.length;
            setRecipe(recipeOptions[recipeIndex]);
          }, 2000);
        });
      });
      recipeRead?.addEventListener('click', () => {
        if (!recipeMore) return;
        const shouldOpen = recipeMore.hidden;
        recipeMore.hidden = !shouldOpen;
        recipeRead.textContent = shouldOpen ? 'Show Less' : 'Read More';
        recipeRead.setAttribute('aria-expanded', String(shouldOpen));
      });
      activateIngredientButtons();
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polkapop-mobile-fix"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => {
    if (!window.matchMedia('(max-width: 620px)').matches) return;
    const grids = Array.from(document.querySelectorAll('.product-grid'));
    grids.forEach((grid) => {
      if (grid.dataset.manualSliderReady === 'true') return;
      grid.dataset.manualSliderReady = 'true';
      const controls = document.createElement('div');
      controls.className = 'pp-slider-controls';
      controls.innerHTML = '<button type="button" aria-label="Previous product">‹</button><span class="pp-slider-count">1 / ' + grid.children.length + '</span><button type="button" aria-label="Next product">›</button>';
      grid.parentElement.appendChild(controls);
      const count = controls.querySelector('.pp-slider-count');
      const cards = Array.from(grid.children);
      const update = () => {
        const index = Math.max(0, Math.min(cards.length - 1, Math.round(grid.scrollLeft / Math.max(1, cards[0].offsetWidth + 14))));
        count.textContent = (index + 1) + ' / ' + cards.length;
      };
      controls.querySelector('button').addEventListener('click', () => grid.scrollBy({left: -(cards[0]?.offsetWidth || 280) - 14, behavior:'smooth'}));
      controls.querySelectorAll('button')[1].addEventListener('click', () => grid.scrollBy({left: (cards[0]?.offsetWidth || 280) + 14, behavior:'smooth'}));
      grid.addEventListener('scroll', update, {passive:true});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polkapop-prototype-base"] && !Shopify.designMode) return;
  try {
    
(() => {
      const heroVideo = document.querySelector('.pp-split-video-hero video');
      if (heroVideo) {
        heroVideo.muted = true;
        heroVideo.loop = true;
        heroVideo.autoplay = true;
        heroVideo.playsInline = true;
        heroVideo.play().catch(() => {});
      }

      const whyCards = Array.from(document.querySelectorAll('.why-card'));
      const whyExperience = document.querySelector('.why-experience');

      const setWhyCard = card => {
        whyCards.forEach(item => item.classList.remove('is-active'));
        card.classList.add('is-active');
        whyExperience?.style.setProperty('--why-soft', card.dataset.soft || '#efffd4');
        whyExperience?.style.setProperty('--why-accent', card.dataset.accent || '#7dbf1d');
      };

      whyCards.forEach(card => {
        card.addEventListener('click', () => setWhyCard(card));
        card.addEventListener('mouseenter', () => setWhyCard(card));
      });

      const momentTabs = Array.from(document.querySelectorAll('.moment-tab'));
      const momentCards = Array.from(document.querySelectorAll('.moment-card[data-moment]'));

      momentTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const filter = tab.dataset.momentFilter || 'all';
          momentTabs.forEach(item => item.classList.remove('is-active'));
          tab.classList.add('is-active');
          momentCards.forEach(card => {
            const isMatch = filter === 'all' || card.dataset.moment === filter;
            card.classList.toggle('is-featured', filter !== 'all' && isMatch);
            card.classList.toggle('is-muted', !isMatch);
          });
        });
      });

      const whySimpleText = document.querySelector('#whySimpleText');
      const whySimpleButtons = Array.from(document.querySelectorAll('.why-simple button'));
      whySimpleButtons.forEach(button => {
        button.addEventListener('click', () => {
          whySimpleButtons.forEach(item => item.classList.remove('is-active'));
          button.classList.add('is-active');
          if (whySimpleText) whySimpleText.textContent = button.dataset.whySimple || '';
        });
      });

      const recipeLab = document.querySelector('.recipe-lab');
      const recipeOptions = Array.from(document.querySelectorAll('[data-recipe-option]'));
      const recipeImage = document.querySelector('#recipeLabImage');
      const recipeTag = document.querySelector('#recipeLabTag');
      const recipeTitle = document.querySelector('#recipeLabTitle');
      const recipeDesc = document.querySelector('#recipeLabDesc');
      const recipeIngredients = document.querySelector('#recipeIngredients');
      const recipeSteps = document.querySelector('#recipeSteps');
      const recipeMore = document.querySelector('#recipeMore');
      const recipeRead = document.querySelector('[data-recipe-more]');

      const activateIngredientButtons = () => {
        Array.from(recipeIngredients?.querySelectorAll('button') || []).forEach(button => {
          button.addEventListener('click', () => {
            button.classList.toggle('is-active');
          });
        });
      };

      const renderRecipeList = (target, items, itemTag) => {
        if (!target) return;
        target.innerHTML = '';
        items.forEach(item => {
          const element = document.createElement(itemTag);
          if (itemTag === 'button') element.type = 'button';
          element.textContent = item;
          target.appendChild(element);
        });
      };

      const setRecipe = option => {
        if (!recipeLab || !option) return;
        recipeOptions.forEach(item => {
          const isActive = item === option;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
        });
        recipeLab.classList.add('is-changing');
        recipeLab.style.setProperty('--recipe-soft', option.dataset.soft || '#efffd4');
        recipeLab.style.setProperty('--recipe-accent', option.dataset.accent || '#7dbf1d');
        window.setTimeout(() => recipeLab.classList.remove('is-changing'), 220);
        if (recipeImage) {
          recipeImage.src = option.dataset.img || recipeImage.src;
          recipeImage.alt = option.dataset.alt || option.dataset.title || 'Polka Pop recipe';
        }
        if (recipeTag) recipeTag.textContent = option.dataset.tag || '';
        if (recipeTitle) recipeTitle.textContent = option.dataset.title || '';
        if (recipeDesc) recipeDesc.textContent = option.dataset.desc || '';
        renderRecipeList(recipeIngredients, (option.dataset.ingredients || '').split('|').filter(Boolean), 'button');
        recipeIngredients?.querySelector('button')?.classList.add('is-active');
        activateIngredientButtons();
        renderRecipeList(recipeSteps, (option.dataset.steps || '').split('|').filter(Boolean), 'li');
        if (recipeMore) {
          recipeMore.hidden = true;
          recipeMore.textContent = option.dataset.detail || '';
        }
        if (recipeRead) {
          recipeRead.textContent = 'Read More';
          recipeRead.setAttribute('aria-expanded', 'false');
        }
      };

      let recipeIndex = Math.max(0, recipeOptions.findIndex(option => option.classList.contains('is-active')));

      const recipePrev = document.querySelector('[data-recipe-prev]');
      const recipeNext = document.querySelector('[data-recipe-next]');

      if (recipePrev) {
        recipePrev.addEventListener('click', () => {
          if (!recipeOptions.length) return;
          recipeIndex = (recipeIndex - 1 + recipeOptions.length) % recipeOptions.length;
          setRecipe(recipeOptions[recipeIndex]);
        });
      }

      if (recipeNext) {
        recipeNext.addEventListener('click', () => {
          if (!recipeOptions.length) return;
          recipeIndex = (recipeIndex + 1) % recipeOptions.length;
          setRecipe(recipeOptions[recipeIndex]);
        });
      }

      recipeOptions.forEach((option, optionIndex) => {
        option.addEventListener('click', () => {
          recipeIndex = optionIndex;
          setRecipe(option);
        });
      });
      recipeRead?.addEventListener('click', () => {
        if (!recipeMore) return;
        const shouldOpen = recipeMore.hidden;
        recipeMore.hidden = !shouldOpen;
        recipeRead.textContent = shouldOpen ? 'Show Less' : 'Read More';
        recipeRead.setAttribute('aria-expanded', String(shouldOpen));
      });
      activateIngredientButtons();
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polkapop-prototype-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var viewport = root.querySelector('.pp-shop-viewport');
    var track = root.querySelector('.pp-shop-track');
    var prev = root.querySelector('.pp-shop-arrow.prev');
    var next = root.querySelector('.pp-shop-arrow.next');
    var dotsWrap = root.querySelector('.pp-shop-dots');
    if(!viewport || !track) return;

    var originals = Array.prototype.slice.call(track.children);
    var total = originals.length;
    if(!total) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var cloneCount = Math.min(3, total);
    originals.slice(0, cloneCount).forEach(function(card){
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button').forEach(function(el){ el.tabIndex = -1; });
      track.appendChild(clone);
    });

    var dots = originals.map(function(_, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-shop-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function(){ stop(); index = i; render(true); start(); });
      dotsWrap.appendChild(b);
      return b;
    });

    var index = 0, timer = null, pointerStart = null;

    function stepSize(){
      var first = track.querySelector('.product-card');
      if(!first) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function setDots(){
      var a = ((index % total) + total) % total;
      dots.forEach(function(d, i){ d.classList.toggle('is-active', i === a); });
    }
    function render(animate){
      track.style.transition = (animate && !reduce) ? 'transform .6s cubic-bezier(.22,.74,.25,1)' : 'none';
      track.style.transform = 'translate3d(' + (-index * stepSize()) + 'px,0,0)';
      setDots();
    }
    function move(dir){
      index += dir;
      if(index < 0){ index = total - 1; render(false); requestAnimationFrame(function(){ render(true); }); return; }
      render(true);
      if(index >= total){ window.setTimeout(function(){ index = 0; render(false); }, 640); }
    }
    function start(){
      if(reduce || document.hidden) return;
      stop();
      timer = window.setInterval(function(){ move(1); }, 4500);
    }
    function stop(){ window.clearInterval(timer); timer = null; }

    if(prev) prev.addEventListener('click', function(){ stop(); move(-1); start(); });
    if(next) next.addEventListener('click', function(){ stop(); move(1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    viewport.addEventListener('pointerdown', function(e){ pointerStart = e.clientX; stop(); });
    viewport.addEventListener('pointerup', function(e){
      if(pointerStart !== null){
        var d = e.clientX - pointerStart;
        if(Math.abs(d) > 45) move(d < 0 ? 1 : -1);
      }
      pointerStart = null;
      start();
    });
    viewport.addEventListener('pointercancel', function(){ pointerStart = null; start(); });
    viewport.addEventListener('click', function(e){
      if(pointerStart !== null){ e.preventDefault(); }
    }, true);
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : start(); });
    window.addEventListener('resize', function(){ render(false); });

    render(false);
    start();
  }

  function boot(){
    document.querySelectorAll('[data-pp-shop-carousel]').forEach(init);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polkapop-recipes"] && !Shopify.designMode) return;
  try {
    
(() => {
  const activateRecipe = choice => {
      const sectionId = choice.dataset.section;
      const group = choice.closest('.pp-recipe-menu');
      group?.querySelectorAll('.pp-recipe-choice').forEach(item => item.classList.remove('is-selected'));
      choice.classList.add('is-selected');
      const flavor = document.getElementById(`recipeFlavor-${sectionId}`);
      const title = document.getElementById(`recipeTitle-${sectionId}`);
      const desc = document.getElementById(`recipeDesc-${sectionId}`);
      const img = document.getElementById(`recipeImg-${sectionId}`);
      const steps = document.getElementById(`recipeSteps-${sectionId}`);
      if (flavor) flavor.textContent = choice.dataset.flavor || '';
      if (title) title.textContent = choice.dataset.title || '';
      if (desc) desc.textContent = choice.dataset.desc || '';
      if (img) {
        img.src = choice.dataset.img || img.src;
        img.alt = choice.dataset.alt || '';
      }
      if (steps) {
        steps.innerHTML = (choice.dataset.steps || '').split('|').map(step => `<span>${step}</span>`).join('');
      }
  };

  document.querySelectorAll('.pp-recipe-menu').forEach(group => {
    const choices = [...group.querySelectorAll('.pp-recipe-choice')];
    if (!choices.length) return;
    let index = Math.max(0, choices.findIndex(choice => choice.classList.contains('is-selected')));
    let timer = window.setInterval(() => {
      index = (index + 1) % choices.length;
      activateRecipe(choices[index]);
    }, 2000);

    choices.forEach((choice, choiceIndex) => {
      choice.addEventListener('click', () => {
        index = choiceIndex;
        activateRecipe(choice);
        window.clearInterval(timer);
        timer = window.setInterval(() => {
          index = (index + 1) % choices.length;
          activateRecipe(choices[index]);
        }, 2000);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
